import React, { Component } from "react";
import { Row } from "react-bootstrap";
import { compose, withStateHandlers } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from "react-google-maps";

import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import OSCard from "../../OSCard/OSCard";

const MapWithAMakredInfoWindow = compose(
  withStateHandlers(
    () => ({
      isOpen: false,
    }),
    {
      onToggleOpen: ({ isOpen }) => () => ({
        isOpen: !isOpen,
      }),
    }
  ),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    defaultZoom={10}
    defaultCenter={{ lat: 36.3931562, lng: 25.4615092 }}
    defaultOptions={{
      styles: [
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [
            { saturation: 36 },
            { color: "#333333" },
            { lightness: 40 },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            { visibility: "on" },
            { color: "#ffffff" },
            { lightness: 16 },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [{ color: "#fefefe" }, { lightness: 20 }],
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [{ color: "#f6f6f6" }, { lightness: "-11" }],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#dedede" }, { lightness: 21 }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [{ color: "#ffffff" }, { lightness: 17 }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-10" }],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-12" }],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#693b1d" }, { lightness: 19 }],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            { color: "#e9e9e9" },
            { lightness: "-47" },
            { saturation: "0" },
          ],
        },
      ],
    }}
  >
    <Marker
      position={{ lat: 36.3931562, lng: 25.4615092 }}
      onClick={props.onToggleOpen}
    >
      {props.isOpen && (
        <InfoWindow onCloseClick={props.onToggleOpen}>
          <div>
            This is just some info for Egina.
            <br /> Please add more if you like.
          </div>
        </InfoWindow>
      )}
    </Marker>
  </GoogleMap>
));

class EventsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [],
    };
  }

  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    let events = [];
    if (nextProps.itineraries && nextProps.itineraries.events) {
      events = nextProps.itineraries.events.map((event) => {
        return (
          <OSCard
            key={event.id}
            id={event.id}
            image={event.imageUrl}
            title={event.eventName}
            link={event.link}
            date={event.startDate}
            description={event.description}
          />
        );
      });
    }

    this.setState({ events });
  }

  render() {
    return (
      <div>
        <Row style={{ margin: "20px 0px", padding: "6px" }}>
          <MapWithAMakredInfoWindow
            isMarkerShown
            googleMapURL="https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyA-Po0FVR5prziiXYtALX9WZXEBtMFnw30&language=en&libraries=geometry"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `400px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
          />
        </Row>
        <Row style={{ margin: "0px" }}>{this.state.events}</Row>
        <Row
          className="BannerRectangleLarge"
          style={{ margin: "40px 0 20px 0", textAlign: "center" }}
        >
          <BannerRectangleLarge />
        </Row>
      </div>
    );
  }
}

export default EventsContent;



// WEBPACK FOOTER //
// ./src/components/Pages/Events/EventsContent.js